import React, { useState } from "react";
import {
  Package,
  Eye,
  ChevronLeft,
  ChevronRight,
  RefreshCw,
  X,
  Save,
  Edit2,
  CheckCircle,
  AlertCircle
} from "lucide-react";
import { format } from "date-fns";

// Simple Alert Component
const Alert = ({ type, message, onClose }) => {
  const types = {
    success: {
      backgroundColor: 'bg-green-50',
      textColor: 'text-green-800',
      borderColor: 'border-green-200',
      icon: <CheckCircle className="w-5 h-5 text-green-500" />
    },
    error: {
      backgroundColor: 'bg-red-50',
      textColor: 'text-red-800',
      borderColor: 'border-red-200',
      icon: <AlertCircle className="w-5 h-5 text-red-500" />
    }
  };

  const style = types[type] || types.error;

  return (
    <div className={`rounded-lg p-4 mb-4 flex items-center justify-between ${style.backgroundColor} ${style.textColor} border ${style.borderColor}`}>
      <div className="flex items-center gap-3">
        {style.icon}
        <p>{message}</p>
      </div>
      {onClose && (
        <button 
          onClick={onClose}
          className="text-gray-500 hover:text-gray-700"
        >
          <X size={18} />
        </button>
      )}
    </div>
  );
};

export default Alert;